import { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AmenitiesComponent from './AmenitiesComponent';

import { getBuildingsForFilter } from '../Building/actionCreators';
import {
  clearAmenities,
  confirmAction,
  getAmenities,
  updateAmenityStatus,
} from './actions';

import { filterObjectByKeyValue, getTodayCount } from '../../utils';
import { arePropsEqual } from './utils';

const LIST_KEY = 'amenityList';

const AmenitiesContainer = (props) => {
  const {
    clearAmenities,
    onConfirmUpdateAmenity,
    onUpdateAmenityStatus,
    onGetAmenities,
    listParams,
  } = props;

  useEffect(() => () => clearAmenities(), []);

  const onAmenityStatusUpdate = (data) => {
    const { upcomingReservationsCount, name, ...rest } = data;
    if (upcomingReservationsCount > 0 && !rest?.active) {
      const bodyText = (
        <span>
          There are <b>{upcomingReservationsCount}</b> existing reservations on{' '}
          <b>{name}</b>. If you inactivate <b>{name}</b>, it will automatically
          cancel all existing reservations. Do you wish to proceed?
        </span>
      );
      return onConfirmUpdateAmenity(bodyText, rest, updateAmenityStatus);
    }
    return onUpdateAmenityStatus(rest);
  };

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetAmenities(queryParams);
  };
  
  return (
    <AmenitiesComponent
      {...props}
      onAmenityStatusUpdate={onAmenityStatusUpdate}
      onExport={onExport}
    />
  );
};

AmenitiesContainer.propTypes = {
  clearAmenities: PropTypes.func.isRequired,
  onConfirmUpdateAmenity: PropTypes.func.isRequired,
  onUpdateAmenityStatus: PropTypes.func.isRequired,
  onGetAmenities: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ amenity, buildings, lists, pmcs }, ownProps) => {
  const listParams = lists?.[LIST_KEY] ?? {};
  const pmcId = ownProps?.match?.params?.PMCId;
  const buildingId = ownProps?.match?.params?.buildingId;
  const selectedBuildingId = listParams?.building;
  const pmc = pmcs?.[pmcId];
  const building = buildings?.[buildingId];
  const items =
    amenity?.amenities && !Array.isArray(amenity.amenities)
      ? amenity.amenities
      : {};
  return {
    pmcId,
    buildingId,
    selectedBuildingId,
    listKey: LIST_KEY,
    listParams,
    items,
    buildings: pmcId
      ? filterObjectByKeyValue(buildings, 'parent.id', +pmcId)
      : buildings,
    pmc,
    building,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const buildingId = ownProps?.match?.params?.buildingId;
  return {
    onLoad: (params) => !buildingId && getBuildingsForFilter(dispatch, params),
    getItems: (queryParams) => {
      getAmenities(dispatch, queryParams);
      getTodayCount(getAmenities, dispatch, queryParams);
    },
    onConfirmUpdateAmenity: (bodyText, data, callback) =>
      confirmAction(dispatch, bodyText, data, callback),
    onUpdateAmenityStatus: (data) => updateAmenityStatus(dispatch, data),
    clearAmenities: () => clearAmenities(dispatch),
    onGetAmenities: (queryParams) => getAmenities(dispatch, queryParams, true),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(AmenitiesContainer, arePropsEqual));
